import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTrending6"><Path fillRule="evenodd" clipRule="evenodd" d="M15.0002 18H22.0002V11H20.0002V14.5858L13.0002 7.58582L9.00015 11.5858L3.00015 5.58582L1.58594 7.00003L9.00015 14.4142L13.0002 10.4142L18.5859 16H15.0002V18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrending6;
